import { useTranslations } from 'next-intl';
import { Box, Text, VStack, HStack, Stack } from '@chakra-ui/react';

import { CryptoIcon } from '@/components/ui/CryptoIcon';
import { useTraderProfile } from '@/lib/hooks/useTraderProfile';

interface TraderProfileProps {
  traderAddress: string;
}

export function TraderProfile({ traderAddress }: TraderProfileProps) {
  const t = useTranslations('trader.detailModal');
  const { data: traderProfile } = useTraderProfile(traderAddress);

  return (
    <Stack mt={6} direction={{ base: "column", md: 'row' }} gap={6}>
      {/* Trade Map Section */}
      {traderProfile?.story && traderProfile.story.length > 0 && (
        <VStack w={{ base: "100%", md: '50%' }} gap={4} p={6} align="start" border=" 1px solid rgba(255, 255, 255, 0.15)" rounded="16px">
          <Text fontSize="xl" color="white" fontWeight="semibold">
            {t('tradeMap')}
          </Text>
          {traderProfile.story.map((story, index) => (
            <VStack
              key={index}
              gap={2}
              rounded="2xl"
              bg="text.t1/8"
              p={4}
              align="start"
            >
              <HStack gap={2} align="center">
                <CryptoIcon symbol={story.symbol} size={24} />
                <Text fontSize="lg" color="white" fontWeight="semibold">
                  {story.symbol}
                </Text>
              </HStack>
              <VStack gap={2} flex={1}>
                <Text fontSize="sm" color="white/90">
                  {story.summary}
                </Text>
              </VStack>
            </VStack>
          ))}
        </VStack>
      )}

      {(!!traderProfile?.insights.length || traderProfile?.suggestion) && (
        <VStack w={{ base: "100%", md: '50%' }} gap={4} p={6} align="start" border=" 1px solid rgba(255, 255, 255, 0.15)" rounded="16px">
          {/* Insights Section */}
          {traderProfile?.insights && traderProfile.insights.length > 0 && (
            <VStack gap={4} align="start">
              <Text fontSize="xl" color="white" fontWeight="semibold">
                {t('insights')}
              </Text>
              <VStack gap={3} align="start">
                {traderProfile.insights.map((insight, index) => (
                  <HStack key={index} gap={3} align="start">
                    <Box
                      mt={2}
                      h={1}
                      w={1}
                      flexShrink={0}
                      rounded="full"
                      bg="text.t1/70"
                    />
                    <Text
                      flex={1}
                      fontSize="sm"
                      color="text.t1/70"
                      fontWeight="medium"
                    >
                      {insight}
                    </Text>
                  </HStack>
                ))}
              </VStack>
            </VStack>
          )}

          {/* What Market Says Section */}
          {traderProfile?.suggestion && (
            <VStack gap={4} align="start">
              <Text fontSize="lg" color="white" fontWeight="semibold">
                {t('whatMarketSays')}
              </Text>
              <VStack gap={3} align="start">
                {traderProfile.suggestion
                  .split('\n')
                  .filter(Boolean)
                  .map((suggestion, index) => (
                    <HStack key={index} gap={3} align="start">
                      <Box
                        mt={2}
                        h={1}
                        w={1}
                        flexShrink={0}
                        rounded="full"
                        bg="text.t1/70"
                      />
                      <Text
                        fontFamily="noto-medium"
                        flex={1}
                        fontSize="sm"
                        color="text.t1/70"
                      >
                        {suggestion.replaceAll(/^"+|"+$/g, '')}
                      </Text>
                    </HStack>
                  ))}
              </VStack>
            </VStack>
          )}

          {/* <HStack justify="center" w="full">
            <Text textAlign="center" fontSize="xs" color="white/40">
              {t('aiDisclaimer')}
            </Text>
          </HStack> */}
        </VStack>
      )}
    </Stack>
  );
}
